import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteCategory($companyId: ID!, $id: ID!) {
    deleteCategory(companyId: $companyId, id: $id) {
      category {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
